import React from "react";

export const UnderLineIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9987 16.5833C15.0329 16.5833 17.4987 14.1175 17.4987 11.0833V3.75H15.207V11.0833C15.207 12.8525 13.7679 14.2917 11.9987 14.2917C10.2295 14.2917 8.79036 12.8525 8.79036 11.0833V3.75H6.4987V11.0833C6.4987 14.1175 8.96453 16.5833 11.9987 16.5833ZM5.58203 18.4167V20.25H18.4154V18.4167H5.58203Z"
        fill="black"
        fill-opacity="0.54"
      />
    </svg>
  );
};
